/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MainDataVersion,
    MainDataVersionFromJSON,
    MainDataVersionFromJSONTyped,
    MainDataVersionToJSON,
} from './';

/**
 * 
 * @export
 * @interface MainDataResvoid
 */
export interface MainDataResvoid {
    /**
     * 
     * @type {MainDataVersion}
     * @memberof MainDataResvoid
     */
    version: MainDataVersion;
    /**
     * 
     * @type {object}
     * @memberof MainDataResvoid
     */
    data?: object | null;
    /**
     * 
     * @type {string}
     * @memberof MainDataResvoid
     */
    error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResvoid
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResvoid
     */
    total?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResvoid
     */
    limit?: number | null;
}

export function MainDataResvoidFromJSON(json: any): MainDataResvoid {
    return MainDataResvoidFromJSONTyped(json, false);
}

export function MainDataResvoidFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainDataResvoid {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': MainDataVersionFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : json['data'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MainDataResvoidToJSON(value?: MainDataResvoid | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': MainDataVersionToJSON(value.version),
        'data': value.data,
        'error': value.error,
        'offset': value.offset,
        'total': value.total,
        'limit': value.limit,
    };
}


